var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 42,
    viewBox: "0 0 197 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3669_223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.9229 0.171143H55.228V7.24021H58.0023L65.23 0.171143H72.5308L62.5044 9.55594L73.5042 19.1357H65.7898L57.905 11.8473H55.228V19.1357H49.9229V0.171143Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M85.0387 0.171143H92.1447L101.684 19.1357H95.8681L94.1402 15.7475H82.8971L81.218 19.1357H75.207L85.0387 0.171143ZM92.315 11.7985L88.543 4.24195L84.8196 11.7985H92.315Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M103.85 0.171143H118.889C121.98 0.171143 123.343 0.463656 124.34 1.36557C125.362 2.24311 125.825 3.87631 125.825 6.4358C125.825 9.97033 125.046 11.3598 122.807 11.896C124.973 12.2861 125.63 13.2855 125.581 16.1619V19.1357H120.203V16.7713C120.179 14.7237 119.644 14.2849 117.283 14.358H109.155V19.1357H103.874L103.85 0.171143ZM117.429 9.72657C119.984 9.72657 120.495 9.3853 120.495 7.50834C120.495 6.28954 120.398 5.77764 120.057 5.36325C119.668 4.9001 119.23 4.82697 117.624 4.82697H109.155V9.72657H117.429Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M138.212 0.171143H145.319L154.858 19.1357H149.042L147.314 15.7475H136.071L134.392 19.1357H128.381L138.212 0.171143ZM145.489 11.7985L141.717 4.24195L137.993 11.7985H145.489Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M161.112 4.85135H153.349V0.171143H174.204V4.85135H166.441V19.1357H161.136L161.112 4.85135Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M196.618 0.171143V4.46133H182.528V7.72773H195.815V11.4816H182.528V14.8455H196.813V19.1357H177.295V0.171143H196.618Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M71.993 34.6632C71.9687 37.4177 71.8957 38.3684 71.5306 39.2216C70.8492 40.8304 69.4378 41.6104 66.7122 41.8054C65.6414 41.9273 63.5485 41.9517 60.0685 41.9517C55.0553 41.9517 53.4249 41.6836 52.0134 40.7085C50.2855 39.5141 49.7988 37.5152 49.7988 31.8844C49.7988 26.8873 50.3099 25.0834 52.1594 23.9378C53.7412 22.9383 55.396 22.6946 60.2875 22.6946C66.8095 22.6946 68.221 22.8408 69.7055 23.6452C71.1169 24.4009 71.774 26.0829 71.774 28.8861V29.5199H66.6878C66.5905 27.4479 66.2011 27.2773 61.5773 27.2773C57.2456 27.2773 56.4425 27.3992 55.7854 28.0086C55.1527 28.6423 55.031 29.398 55.031 32.4694C55.031 37.0277 55.4204 37.369 60.5309 37.369C64.4733 37.369 65.0573 37.3446 65.7874 37.0033C66.5418 36.6621 66.8338 36.0527 66.8338 34.712L71.993 34.6632Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M93.1165 22.9139C95.8178 23.4502 97.1319 24.9615 97.497 28.0085C97.5943 28.7642 97.643 30.2998 97.643 32.6156C97.643 37.1983 97.2049 39.0509 95.6961 40.3915C94.6497 41.3666 93.1895 41.8054 90.6343 41.9272C89.6852 41.976 87.3733 42.0247 85.6698 42.0247C81.5084 42.0247 79.3912 41.9272 78.3447 41.7079C76.3979 41.3422 75.2784 40.5378 74.6214 39.1484C73.94 37.7589 73.7939 36.3695 73.7939 32.2012C73.7939 29.0079 73.8426 28.2279 74.159 26.9359C74.6457 24.9127 75.6678 23.8402 77.639 23.2064C79.0991 22.7433 80.7053 22.6458 85.3048 22.6458C90.3422 22.6458 91.8754 22.6945 93.1165 22.9139ZM80.0969 27.9597C79.3912 28.5448 79.1721 29.4954 79.1721 32.2256C79.1721 35.0044 79.3912 36.0282 80.0239 36.6376C80.7296 37.2714 81.6057 37.3689 85.5968 37.3689C90.1719 37.3689 91.121 37.1983 91.7294 36.2964C92.2161 35.6138 92.3621 34.6388 92.3621 32.1281C92.3621 27.3503 92.2891 27.3016 85.7428 27.3016C81.8491 27.2772 80.7783 27.4235 80.0969 27.9597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.8584 22.8408H108.279L114.63 35.4433L120.957 22.8408H129.329V41.8054H124.145L124.413 27.1554L116.674 41.8054H112.44L104.823 27.1554L104.993 41.8054H99.8584V22.8408Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M131.932 22.8408H147.677C149.697 22.8408 150.792 23.0358 151.692 23.5234C153.104 24.3278 153.688 25.5953 153.688 28.0086C153.688 30.4705 152.909 31.7625 151.254 32.1037C153.615 32.5913 154.394 33.6882 154.394 36.4671C154.394 38.8559 153.761 40.3672 152.374 41.1473C151.571 41.6104 150.402 41.8054 148.407 41.8054H131.932V22.8408ZM146.046 30.3974C147.068 30.3974 147.434 30.3487 147.774 30.178C148.188 29.9099 148.456 29.4224 148.456 28.7642C148.456 28.0086 148.115 27.4235 147.531 27.2041C147.19 27.0823 146.922 27.0579 145.9 27.0579H137.115V30.4218H146.046V30.3974ZM146.606 37.5884C147.677 37.5884 147.896 37.564 148.237 37.4421C148.772 37.2471 149.064 36.6864 149.064 35.882C149.064 35.0532 148.748 34.4926 148.164 34.2732C147.847 34.1513 147.628 34.127 146.46 34.127H137.091V37.5884H146.606Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M164.396 22.8408H171.502L181.042 41.8054H175.225L173.498 38.4171H162.255L160.575 41.8054H154.564L164.396 22.8408ZM171.672 34.4682L167.9 26.9116L164.177 34.4682H171.672Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M185.616 27.521H177.245V22.8408H196.811V27.521H190.921V41.8054H185.616V27.521Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28.6759 8.361H9.15868V41.8537H0.811523V0H28.6759V8.361ZM42.596 0V41.8537H14.7072V33.4927H34.2488V0H42.596Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3669_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 42,
    fill: "white",
    transform: "translate(0.811523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo6.2f9520b808f2f4d14e1e7a54ac7799b5.svg";
export { ForwardRef as ReactComponent };